<script lang="ts">
  import { Lazy } from "@opera-gx/components";

  import BannerSection from "../sections/BannerSection.svelte";
  import CalendarSection from "../sections/CalendarSection.svelte";
  import DailySection from "../sections/DailySection.svelte";
  import DesktopDealsSection from "../sections/DesktopDealsSection.svelte";
  import GameTabSection from "../sections/GameTabSection.svelte";
  import NewsSection from "../sections/NewsSection.svelte";
  import Placeholder from "../sections/Placeholder.svelte";
  import WatchTabSection from "../sections/WatchTabSection/WatchTabSection.svelte";
  import type { PageData } from "./$types";

  export let data: PageData;
</script>

<div class="flex flex-col gap-12">
  {#each data.data as section}
    {@const component = section.__component}
    {@const { key, id, section_title } = section}
    {@const promise = section.items}

    {#if component === "sections.calendar-section"}
      <Lazy {promise} let:data={items}>
        <CalendarSection {items} {section_title} {id} {key} />
        <svelte:fragment slot="loading">
          <Placeholder variant="calendar" tiles={4} />
        </svelte:fragment>
      </Lazy>
    {/if}

    {#if component === "sections.daily-section"}
      <Lazy {promise} let:data={items}>
        <DailySection {items} {section_title} {key} />
        <svelte:fragment slot="loading">
          <Placeholder variant="daily" tiles={1} />
        </svelte:fragment>
      </Lazy>
    {/if}

    {#if component === "sections.banner-section"}
      <Lazy {promise} let:data={items}>
        <BannerSection {items} {key} />
        <svelte:fragment slot="loading">
          <Placeholder variant="banner" tiles={1} />
        </svelte:fragment>
      </Lazy>
    {/if}

    {#if ["sections.deals", "sections.deal-aggregator", "sections.free-games", "sections.top-games-section"].includes(component)}
      <Lazy {promise} let:data={items}>
        <DesktopDealsSection {component} {items} {section_title} {id} {key} />
        <svelte:fragment slot="loading">
          <Placeholder variant="deals" tiles={8} />
        </svelte:fragment>
      </Lazy>
    {/if}

    {#if component === "sections.trailer-section" || component === "sections.video-section"}
      <Lazy {promise} let:data={items}>
        <WatchTabSection {items} {section_title} {key} />
        <svelte:fragment slot="loading">
          <Placeholder variant="videos" tiles={4} />
        </svelte:fragment>
      </Lazy>
    {/if}

    {#if component === "sections.html-games-section"}
      <Lazy {promise} let:data={items}>
        <GameTabSection {items} lazy {section_title} />
        <svelte:fragment slot="loading">
          <Placeholder variant="games" tiles={8} />
        </svelte:fragment>
      </Lazy>
    {/if}

    {#if component === "sections.news-section"}
      <Lazy {promise} let:data={items}>
        <NewsSection {items} {section_title} {key} />
        <svelte:fragment slot="loading">
          <Placeholder variant="news" tiles={4} />
        </svelte:fragment>
      </Lazy>
    {/if}
  {/each}
</div>
